import '@app/App.css';
import WorkspaceSelector from './WorkspaceSelector';
import AppHeaderNav from './AppHeaderNav';
import { TW_AppHeader } from '@utils/twClasses';
import AppBreadcrumb from './AppBreadcrumb';
import BurgerMenu from './BurgerMenu';
import { useModelStore } from 'src/store';
import { DEFAULT_COMPOZZ_COLOR } from '@utils/colors';
import { useState, useEffect } from 'react';

interface WorkspaceHeaderProps {
  onMobileSidebarToggle?: () => void;
  isMobileSidebarOpen?: boolean;
}

function WorkspaceHeader({ onMobileSidebarToggle, isMobileSidebarOpen = false }: WorkspaceHeaderProps) {
  const workspace = useModelStore(state => state.selectedWorkspace);
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 640); // md breakpoint
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <header className={TW_AppHeader} style={{backgroundColor: workspace?.color ?? DEFAULT_COMPOZZ_COLOR }}>
      <WorkspaceSelector/>
      {isMobile ? (
        <BurgerMenu 
          onToggle={onMobileSidebarToggle || (() => {})} 
          isOpen={isMobileSidebarOpen} 
        />
      ) : (
        <AppBreadcrumb/>
      )}
      <AppHeaderNav />
    </header>
  );
};

export default WorkspaceHeader;